/* v8 ignore start */
import {configureStore} from "@reduxjs/toolkit";
import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";

import {errorLoggingMiddleware} from "./middleware/errorLoggingMiddleware";
import {eventListenerMiddleware} from "./middleware/eventListenerMiddleware";
import animatedProjectReducer from "./slices/animatedProjectSlice/animatedProjectSlice";
import authReducer from "./slices/authSlice";
import featureReducer from "./slices/featuresSlice";
import playerReducer from "./slices/playerSlice";
import viewReducer from "./slices/viewSlice";

export interface IResponse<T> {
  data: T;
}

export const store = configureStore({
  reducer: {
    animatedProject: animatedProjectReducer,
    auth: authReducer,
    player: playerReducer,
    view: viewReducer,
    features: featureReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(errorLoggingMiddleware, eventListenerMiddleware),
});

export type TRootState = ReturnType<typeof store.getState>;
type TAppDispatch = typeof store.dispatch;

export const useAppDispatch: () => TAppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<TRootState> = useSelector;
/* v8 ignore stop */
